import PropTypes from 'prop-types';
import React from 'react';
import DesktopHeader from './DesktopHeader';
import TabletHeader from './TabletHeader';
import { ThemeProvider, useIsTabletDevice } from './common/theme-context';

const Header = ({ serverRouted, userId, userPermissions }) => {
  const { isTabletDevice } = useIsTabletDevice();

  if (isTabletDevice) {
    return (
      <TabletHeader
        serverRouted={serverRouted}
        userPermissions={userPermissions}
      />
    );
  }

  return <DesktopHeader userId={userId} userPermissions={userPermissions} />;
};

export default props => (
  <ThemeProvider>
    <Header {...props} />
  </ThemeProvider>
);

Header.propTypes = {
  userId: PropTypes.number.isRequired,
  userPermissions: PropTypes.arrayOf(PropTypes.string),
  serverRouted: PropTypes.bool
};
